/** @format */

import { brokerLogoutApiService } from 'services/apiService';
import { push } from 'connected-react-router';
import { persistor, store } from 'stateContainer/store';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actionTypes from 'stateContainer/action-types';

const LOGOUT_LANDING_URL = '/';

function* workerSaga() {
  const { session } = store.getState();
  const refreshToken = session.data.refreshToken;

  localStorage.removeItem('persist:root');
  persistor.purge();
  yield put({ type: actionTypes.ACTIVE_INDEX, payload: 0 });
  yield put({ type: actionTypes.ACTIVE_INDEX_INFO_CENTER, payload: 0 });

  try {
    const response = yield call(brokerLogoutApiService, { refreshToken });
    if (response.data.status == 'success') {
      yield put({ type: actionTypes.LOGOUT_SUCCESS });
      yield put(push(LOGOUT_LANDING_URL));
    } else {
      throw new Error('Logout failed');
    }
  } catch (error) {
    yield put({ type: actionTypes.LOGOUT_FAILED, error });
    yield put(push(LOGOUT_LANDING_URL));
  }
}

export function* logoutSaga() {
  yield takeLatest(actionTypes.LOGOUT_REQUESTED, workerSaga);
}
